import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { supabase } from "../lib/supabase";

export function RequireAuth(): JSX.Element {
  const [status, setStatus] = useState<"checking" | "authed" | "unauthed">(
    "checking",
  );

  useEffect(() => {
    let mounted = true;
    void supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setStatus(data.session ? "authed" : "unauthed");
    });
    const sub = supabase.auth.onAuthStateChange((_event, session) => {
      if (!mounted) return;
      setStatus(session ? "authed" : "unauthed");
    });
    return () => {
      mounted = false;
      sub.data.subscription.unsubscribe();
    };
  }, []);

  if (status === "checking") {
    return <div className="empty">Checking session…</div>;
  }
  if (status === "unauthed") {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
